import React from 'react'

import { BasePageProps } from '@/Pages/types'

import Page from '@/Components/Pages/Accounts/Page'
import PageProvider from '@/Components/Pages/PageProvider'

export type TimeZoneOption = [string, string]

export type AccountPageProps = BasePageProps & {
  timeZoneOptions: TimeZoneOption[]
}

const AccountPage: React.FC<AccountPageProps> = ({
  currentUser,
  env,
  ...props
}) => {
  return (
    <PageProvider env={env} currentUser={currentUser} title="Edit Account">
      <Page {...props} />
    </PageProvider>
  )
}

export default AccountPage
